<template>
	<el-container style=" border: 1px solid #eee">
	  <el-main>
		<!-- 添加搜索框 -->
		<el-input v-model="searchText" placeholder="请输入关键词进行搜索" clearable @input="handleSearch"></el-input>
		<el-table 
		:data="filteredTableData"
		@select="select"
        @select-all="selectAll"
        @selection-change="selectionChange"
		>
		<el-table-column type="selection" width="55"> </el-table-column>
		  <el-table-column prop="deviceName" label="设备名称" width="400"></el-table-column>
		  <el-table-column prop="reMark" label="备注" width="300">
		  </el-table-column>
		  <el-table-column prop="position" label="设备位置" width="200" sortable></el-table-column>
		  <el-table-column prop="isRegister" label="授权信息" width="350">
			<template slot-scope="scope">
			  <span :class="scope.row.isRegister === '已注册'? 'online-dot' : 'offline-dot'"></span><span style="margin-left: 5px;">{{scope.row.registerInfo}}</span>
			</template>
		  </el-table-column>
		  <el-table-column prop="deviceId" label="设备ID" width="350"></el-table-column>
		  <el-table-column prop="osName" label="设备系统" width="300"></el-table-column>
		  <el-table-column prop="ipAddress" label="外网IP" width="200"></el-table-column>
		  <el-table-column prop="lanIpAddress" label="内网IP" width="200"></el-table-column>
		  <el-table-column prop="cpuName" label="CPU型号" width="350"></el-table-column>
		  <el-table-column prop="graphicsName" label="显卡型号" width="300"></el-table-column>
		  <el-table-column prop="memorySize" label="内存大小" width="100"></el-table-column>
		  <el-table-column prop="MACList" label="网卡信息" width="800"></el-table-column>
		  <el-table-column fixed="right" label="操作" width="600">
			<template slot-scope="scope">
			  <el-button type="primary" @click="add(scope.row)" size="small">设备授权</el-button>
			  <el-button type="success"  size="small"  @click="openRemarkPopup(scope.row)">修改备注</el-button>

			  <el-button type="warning" @click="syncRegisterInfo(scope.row)" size="small" plain>同步注册</el-button>
			  <el-button type="danger" @click="lockDevice(scope.row)" size="small" plain>锁定设备</el-button>
			  <el-button type="success" @click="unLockDevice(scope.row)" size="small" plain>设备解锁</el-button>
			  <el-button type="danger" @click="Revokeauthorization(scope.row)" size="small" >解除授权</el-button>
			</template>
		  </el-table-column>
		</el-table>
		
		<el-button v-if="this.ruleAllForm.selectedIds.length > 0" type="warning" @click="batchRegister()" size="small" >批量注册</el-button>
<!-- 新增复选框选择的模态框 -->
<el-dialog title="批量注册" :visible.sync="batchDialogVisible" width="50%">
       
	   <el-form ref="ruleAllForm" :model="ruleAllForm":rules="rules" label-width="80px">
		   <el-form-item label="授权类型" prop="type">
			   <el-select v-model="ruleAllForm.type" placeholder="请选择授权类型">
				   <el-option label="永久" value="forever"></el-option>
				   <el-option label="天数" value="day"></el-option>
				   <el-option label="次数" value="frequency"></el-option>
			   </el-select>
		   </el-form-item>
		   <el-form-item  v-if="ruleAllForm.type=='day'" label="授权天数"  >
			   <el-date-picker prop="day"
				   v-model="value1"
				   type="datetime"
				   placeholder="选择结束日期时间">
				   prop="day"
			   </el-date-picker>
		   </el-form-item>
		   <el-form-item  v-if="ruleAllForm.type=='frequency'" label="授权次数" >
			   <el-input v-model="ruleAllForm.time" placeholder="请输入授权次数" ></el-input>
		   </el-form-item>
		  
		   <el-form-item >
			   <el-button @click="batchDialogVisible = false">取 消</el-button>
				   <el-button type="primary" @click="submitForm('ruleAllForm')">确 定</el-button>
		   </el-form-item> 
	   </el-form>
	   
   </el-dialog>

	<!-- 返回注册码弹出框 -->
	<el-dialog title="注册码" :visible.sync="dialogV" width="70%">
	 <el-table :data="codeList" style="width: 100%">
	   <el-table-column prop="deviceId" label="设备ID" width="300"></el-table-column>
	   <el-table-column prop="registerCode" label="注册码"  width="800"></el-table-column>
	 </el-table>
	 <span slot="footer" class="dialog-footer">
	   <el-button @click="dialogV = false">关闭</el-button>
	 </span>
   </el-dialog>

   <!-- 修改备注弹出框 -->
	<el-dialog  :visible.sync="dialogRemarkPopup" width="30%">
		<div style="width:300px; height:300px;  padding:10px;"> 
												
			<h3 style="text-align: center;margin-bottom: 20px;">备注修改</h3> 
		   <div  style="color:#6a6a6a;">设备ID: {{UpdateRemarkRequest.deviceID}}</div> 
		   <el-input v-model="UpdateRemarkRequest.remark" placeholder="请输入设备备注" style="margin-top: 10px;"></el-input>
		   
		  
		<el-button type="danger" @click="submitRemark" style="margin-top: 10px;">点击提交</el-button> 
		<el-button type="success" @click="closeRemarkPopup" style="margin-top: 10px;">点击取消</el-button> 
	  </div>
   </el-dialog>
	  </el-main>
	  <el-footer>
	  </el-footer>
	</el-container>
  </template>
  
  <style>
	* {
	  margin: 0;
	  padding: 0;
	}
	.focus-border .el-input__inner:focus {
  border-color: #409EFF; /* 聚焦时的边框颜色 */
  box-shadow: 0 0 5px rgba(24, 144, 255, 0.4);
}
 
.focus-border .el-input__inner:blur {
  border-color: #dcdfe6; /* 失焦时的边框颜色 */
  box-shadow: none;
}
  .online-dot {
	  display: inline-block;
	  width: 5px;
	  height: 5px;
	  background-color: rgb(0, 255, 0);
	  border-radius: 50%;
	}
  
  .offline-dot {
	  display: inline-block;
	  width: 5px;
	  height: 5px;
	  background-color: gray;
	  border-radius: 50%;
	}
  
  .el-header {
	  background-color: #B3C0D1;
	  color: #333;
	  line-height: 60px;
	}
  
  .el-aside {
	  color: #333;
	}
  </style>
  
  <script>
  import Axios from 'axios'
  export default {
	data() {
	  return {
		UpdateRemarkRequest:{
									 deviceID:'',
									 remark:'',
			},
		params:[],
          pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        value1: '',


		canClick: true,
		cClick: true,
		searchText: '', // 用于存储搜索关键词
		tableData: [],
		filteredTableData: [], // 存储过滤后的表格数据
		dialogVisible: false,
		infodialog: false,
		batchDialogVisible: false,
		dialogRemarkPopup:false,
		dialogV: false,
		codeList: {

		},
		ruleAllForm: {
            type: '',
            time:'',
            startTime:'',
            endTime:'',
            selectedIds: [],
            creatTime:''
          
          },
		  rules: {
            
            type: [
              { required: true, message: '请选择授权类型', trigger: 'change' }
            ],
            day:[
            { required: true, message: '请输入授权天数', trigger: 'blur' }
            ],
           
            
           
          }
	  }
	},
	created() {
	  this.request.get("/getDevices").then(res => {
		console.log(res)
		this.tableData = res.info
		this.filteredTableData = res.info; // 初始化过滤后的数据
	  }).catch(error => {
		console.log(error)
	  })
	},
	methods: {
		openRemarkPopup(item) {
			this.UpdateRemarkRequest.deviceID=item.deviceId;
			this.dialogRemarkPopup = true;
		},
		closeRemarkPopup(){
			this.dialogRemarkPopup = false;
			this.UpdateRemarkRequest.deviceID='';
			this.UpdateRemarkRequest.remark='';
		},
		
		submitRemark(){
			
			if(this.UpdateRemarkRequest.deviceId===''){
				this.$message.error('设备ID不能为空');
				
				return;
			}
			if(this.UpdateRemarkRequest.remark===''){
				this.$message.error('备注不能为空');
				
				return;
			}
			// 假设 request 是封装好的请求工具
			this.request.post("/updateRemark", this.UpdateRemarkRequest).then(res => {
			    if (res.code === '0') {
			        console.log('设备备注修改成功');
			        this.closeRemarkPopup(); // 假设关闭弹窗的方法名是 closePopup
					this.$message({ message: res.data, type: 'success' });
			        this.request.get("/getDevices").then(res => {
		console.log(res)
		this.tableData = res.info
		this.filteredTableData = res.info; // 初始化过滤后的数据
	  }).catch(error => {
		console.log(error)
	  })
			    } else {
			        console.log('设备备注修改失败');
			        this.closeRemarkPopup();
					this.$message.error(res.msg);
			    }
			}).catch(errors => {
			    console.log(errors);
			    this.closeRemarkPopup();
				this.$message.error('请求出错，请稍后重试');
			    
			});
		},

		batchRegister() {
            this.batchDialogVisible = true;
        },
	  add(row) {
		const deviceid = row.deviceId
		const _name = row.deviceName
		this.$router.push({ path: '/home/RegisterDevice', query: { id: deviceid, Name: _name } })
	  },
	  Revokeauthorization(row) {
		const deviceid = row.deviceId
		this.$router.push({ path: '/home/DeleteRegisterInfo', query: { id: deviceid} })
	  },
	  lockDevice(row) {
		if (!this.canClick) return // 已经触发过点击事件
      // 点击事件逻辑
      // ...
      
		const deviceid = row.deviceId;
		console.log('要锁定的设备ID：', deviceid);
		// 执行锁定设备的逻辑
		this.request.get("/LockDevice", { params: { "ID": deviceid } }).then(res => {
		  if (res.code == '0') {
			this.$message({ message: res.data, type: 'success' });
		  } else {
			this.$message.error(res.msg);
		  }
		}).catch(error => { console.log(error) })
		this.canClick = false // 将标志变量设为 false
      setTimeout(() => {
        this.canClick = true // 三秒后将标志变量设为 true
      }, 5000)


	  },
	  unLockDevice(row) {
		if (!this.cClick) return // 已经触发过点击事件
		const deviceid = row.deviceId;
		console.log('要解锁的设备ID：', deviceid);
		// 执行锁定设备的逻辑
		this.request.get("/UnLockDevice", { params: { "ID": deviceid } }).then(res => {
		  if (res.code == '0') {
			this.$message({ message: res.data, type: 'success' });
		  } else {
			this.$message.error(res.msg);
		  }
		}).catch(error => { console.log(error) })
		this.cClick = false // 将标志变量设为 false
      setTimeout(() => {
        this.cClick = true // 三秒后将标志变量设为 true
      }, 5000)
	  },
	  syncRegisterInfo(row) {
		const deviceid = row.deviceId;
		console.log('要同步的设备ID：', deviceid);
		// 执行锁定设备的逻辑
		this.request.get("/SyncRegisterInfo", { params: { "ID": deviceid } }).then(res => {
		  if (res.code == '0') {
			this.$message({ message: res.data, type: 'success' });
		  } else {
			this.$message.error(res.msg);
		  }
		}).catch(error => { console.log(error) })
	  },

	  select(selection, row) {
                if (selection.length) {
                    this.ruleAllForm.selectedIds = [row.deviceId];
                } else {
                    this.ruleAllForm.selectedIds  = [];
                }
            },
            // 处理全选事件
            selectAll(selection) {
                this.ruleAllForm.selectedIds  = selection.map(item => item.deviceId);
            },
            // 处理选择变化事件
            selectionChange(selection) {
                this.ruleAllForm.selectedIds  = selection.map(item => item.deviceId);
				console.log(this.ruleAllForm.selectedIds );
            },

			submitForm(formName) {
         
         this.$refs[formName].validate((valid) => {
           if (valid) {
             if(this.ruleAllForm.time=="" && this.ruleAllForm.type=="frequency"){
               this.$message.error("请输入授权次数");
             }else if( this.ruleAllForm.selectedIds.length<=0){
                this.$message.error("请勾选注册设备");
             }else{

               const timestamp = new Date().getTime();
               const date = new Date(timestamp);
               this.ruleAllForm.creatTime= date.toLocaleString();
               if(this.ruleAllForm.type=="day"){
                 const timestamp1 =this.value1.getTime();
                 const date1 = new Date(timestamp1);
                 this.ruleAllForm.endTime=date1.toLocaleString()
               }
               console.log('准备批量注册的设备ID:', this.ruleAllForm.selectedIds);

               const loading = this.$loading({
          lock: true,
          text: '正在注册',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
       
               this.request.post("/DeviceAllRegister", this.ruleAllForm).then(res => {
                if(res.code=='0'){
                      this.$message({message: '设备授权成功',type: 'success'});
                      console.log(res);
                      loading.close();
                      this.ruleAllForm.selectedIds=[];
                      this.codeList =JSON.parse(res.registerCode);
                      this.batchDialogVisible = false;
                      this.dialogV=true;
                     
                 }else{
                      this.$message.error(res.msg);
                      this.batchDialogVisible = false;
                      this.ruleAllForm.selectedIds=[];
                }
            })
           
             }
              
           } else {
             console.log('error submit!!');
             return false;
           }
         });
       },

	  // 处理搜索逻辑的方法
	  handleSearch() {
		const searchText = this.searchText.trim().toLowerCase(); // 获取去除空格并转为小写的搜索关键词
		if (searchText === '') {
		  this.filteredTableData = this.tableData; // 如果关键词为空，显示全部数据
		  return;
		}
		this.filteredTableData = this.tableData.filter(item => {
		  return Object.values(item).some(value => {
			if (typeof value ==='string') {
			  return value.toLowerCase().includes(searchText); // 对每一行数据的每个属性值（如果是字符串类型）进行模糊匹配
			}
			return false;
		  });
		});
	  }
	}
  };
  </script>